import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { MonthPlanService } from "../../services/monthPlanService";
import logger from "../../core/utils/logger";

// Async thunk to get user's month plan by month and year
export const getUserMonthPlanInOrgByMonthAndYear = createAsyncThunk(
    "monthPlan/getUserMonthPlanInOrgByMonthAndYear",
    async ({ month, year }, { rejectWithValue }) => {
        try {
            const response = await MonthPlanService.getUserMonthPlan(month, year);
            logger.log("User month plan response:", JSON.stringify(response));
            return response;
        } catch (error) {
            logger.error("Error getting user month plan:", error);
            return rejectWithValue(error.response?.data || "Error getting month plan");
        }
    }
);

const initialState = {
    MonthPlanData: {
        monthPlanSchedules: [],
        loading: false,
        error: null
    }
};

const monthPlanSlice = createSlice({
    name: "monthPlan",
    initialState,
    reducers: {
        clearMonthPlanState: (state) => {
            state.MonthPlanData.monthPlanSchedules = [];
            state.MonthPlanData.loading = false;
            state.MonthPlanData.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUserMonthPlanInOrgByMonthAndYear.pending, (state) => {
            state.MonthPlanData.loading = true;
            state.MonthPlanData.error = null;
        });
        builder.addCase(getUserMonthPlanInOrgByMonthAndYear.fulfilled, (state, action) => {
            state.MonthPlanData.monthPlanSchedules = action.payload;
            state.MonthPlanData.loading = false;
            state.MonthPlanData.error = null;
        });
        builder.addCase(getUserMonthPlanInOrgByMonthAndYear.rejected, (state, action) => {
            state.MonthPlanData.loading = false;
            state.MonthPlanData.error = action.payload;
        });
    }
});

export const { clearMonthPlanState } = monthPlanSlice.actions;
export default monthPlanSlice.reducer;
